import { gql } from '@apollo/client'

export const LOCATION_FRAGMENT = gql`
  fragment Location on Location {
    id
    name
    address1
    address2
    city
    postalCode
    state
    county
  }
`
